(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            $routeProvider
                .when('/free/:moduleId', {
                    templateUrl: require('../templates/free.html'),
                    resolve: {
                        resolve: ['$route', 'config', function ($route, config) {
                            return $routeProvider.ResolverFactory.moduleIsActivated("free-" + $route.current.params.moduleId).resolver(config);
                        }]
                    }
                });
        }]);

})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/free/routes/free-routes.js